import { render, staticRenderFns } from "./Major.vue?vue&type=template&id=35597b37&scoped=true"
import script from "./Major.vue?vue&type=script&lang=ts"
export * from "./Major.vue?vue&type=script&lang=ts"
import style0 from "./Major.vue?vue&type=style&index=0&id=35597b37&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35597b37",
  null
  
)

export default component.exports